module.exports = __webpack_public_path__ + "img/top.842cfb0c.svg";